export const SESSION_DELETE_SUCCESS_MESSAGE = 'You session has been deleted';
export const SESSION_ARCHIVE_SUCCESS_MESSAGE = 'You session has been archived';
